import Box from '@/common/components/Box'
import { DocumentFileList } from '@/common/components/DocumentFileList'
import { getFilenameFromUrl } from '@/common/utils/getFilenameFromUrl'
import { fiscalAssessmentDocumentGroupsKind } from '@/features/maintenanceWorkflow/pages/Show/features/fiscalAssessments/constants/fiscalAssessmentDocumentGroupsKind.constant'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { MaintenanceFiscalAssessmentEntryStatus } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/fiscalAssessmentEntry/fiscalAssessmentEntry.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import React, { useMemo } from 'react'

const MaintenanceWorkflowForwardingFiscalAssessmentEntrySection = () => {
  const { forwarding, forwardingUpdatedAt } =
    useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>()

  const isAwaitingEstablishmentDocuments = useMemo(() => {
    return (
      forwarding?.fiscal_assessment_entry?.status ===
      MaintenanceFiscalAssessmentEntryStatus.AwaitingEstablishmentDocuments
    )
  }, [forwardingUpdatedAt])

  const isAwaitingManagementReview = useMemo(() => {
    return (
      forwarding?.fiscal_assessment_entry?.status === MaintenanceFiscalAssessmentEntryStatus.AwaitingManagementReview
    )
  }, [forwardingUpdatedAt])

  const isCompleted = useMemo(() => {
    return forwarding?.fiscal_assessment_entry?.status === MaintenanceFiscalAssessmentEntryStatus.Completed
  }, [forwardingUpdatedAt])

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex flex-col">
        <p className="text-lg font-semibold">Recolha de notas</p>

        {isAwaitingEstablishmentDocuments && <p className="text-warning text-xs">Aguardando notas</p>}

        {isAwaitingManagementReview && <p className="text-warning text-xs">Aguardando aprovação</p>}

        {isCompleted && <p className="text-valid text-xs">Concluído</p>}
      </div>

      <div className="flex flex-col gap-3">
        {forwarding?.fiscal_assessment_entry?.document_groups?.map((documentGroup, index) => (
          <React.Fragment key={documentGroup.id}>
            {index > 0 && <div className="h-px bg-white-200" />}

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <div>
                  <p>{fiscalAssessmentDocumentGroupsKind[documentGroup.kind] || documentGroup.kind}</p>
                </div>
              </div>

              {Number(documentGroup.documents.length) > 0 && (
                <DocumentFileList
                  files={documentGroup.documents.map((document) => ({
                    currentFileUrl: document.file.url,
                    fileName: getFilenameFromUrl(document.file.url),
                  }))}
                  className="h-[120px] w-[220px] p-3 rounded-md"
                />
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </Box>
  )
}

export default MaintenanceWorkflowForwardingFiscalAssessmentEntrySection
